import React from 'react';
import Courses from '../components/Courses';
import Activities from '../components/Activities';
import { FiCheckCircle, FiBookOpen } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SEO from '../components/SEO';

const Program = () => {
  return (
    <div className="animate-fadeIn">
      <SEO page="program" />
      {/* Hero Section with Background */}
      <section className="relative bg-gradient-to-br from-orange-900 via-amber-800 to-yellow-900 pt-32 pb-40 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-4 border-white rounded-full"></div>
          <div className="absolute top-20 right-20 w-20 h-20 border-4 border-white"></div>
          <div className="absolute bottom-10 left-1/4 w-24 h-24 border-4 border-white rounded-full"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Breadcrumbs */}
          <div className="flex items-center justify-center space-x-2 text-sm text-orange-200 mb-6" data-aos="fade-down">
            <a href="/" className="hover:text-white transition-colors">Home</a>
            <span className="text-orange-400">/</span>
            <span className="text-white font-medium">Programs</span>
          </div>

          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-aos="fade-up">
              <SafeIcon icon={FiBookOpen} className="w-5 h-5 text-white" />
              <span className="text-white font-medium">Our Programs</span>
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" data-aos="fade-up" data-aos-delay="100">
              Our Programs
            </h1>
            
            <p className="text-xl text-orange-100 leading-relaxed" data-aos="fade-up" data-aos-delay="200">
              Discover our comprehensive age-appropriate programs designed to foster holistic development 
              and prepare your child for a bright future.
            </p>
          </div>
        </div>

        {/* Decorative Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full h-auto">
            <path fill="#ffffff" fillOpacity="1" d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"></path>
          </svg>
        </div>
      </section>

      <Courses />
      
      {/* Curriculum Highlights */}
      <section className="py-20 bg-[#FDFBF7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Our Holistic Curriculum</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">We follow a research-backed, play-based approach that integrates global standards with local cultural values.</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              "Play-Based Learning",
              "Montessori Methods",
              "STEM Integration",
              "Creative Arts",
              "Social-Emotional Skills",
              "Physical Development",
              "Language Mastery",
              "Robotics Basics"
            ].map((item, idx) => (
              <div key={idx} className="flex items-center space-x-3 bg-white p-5 rounded-2xl shadow-sm border border-emerald-50">
                <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-emerald-600 flex-shrink-0" />
                <span className="font-semibold text-gray-800">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Activities />
    </div>
  );
};

export default Program;